import { EStatus } from '../types/offers';
import * as React from 'react';
import { IconActionCompareAdd24, IconActionCompareAdded24 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export function useCompare(_ref) {
  var status = _ref.status;
  var icon = React.useMemo(function () {
    switch (status) {
      case EStatus.Added:
        return /*#__PURE__*/_jsx(IconActionCompareAdded24, {
          color: "current_color"
        });
      case EStatus.Available:
        return /*#__PURE__*/_jsx(IconActionCompareAdd24, {
          color: "current_color"
        });
      default:
        return null;
    }
  }, [status]);
  var tooltipText = React.useMemo(function () {
    switch (status) {
      case EStatus.Added:
        return 'Добавлено в сравнение';
      case EStatus.Available:
        return 'Добавить к сравнению';
      default:
        return null;
    }
  }, [status]);
  return {
    tooltipText: tooltipText,
    icon: icon
  };
}